var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "price__cols"
  }, [_c('div', {
    staticClass: "price__common",
    class: _vm.beautifyPriceDiscount && 'price__common_red'
  }, [_c('p', [_vm._v(_vm._s(((_vm.beautifyPriceCommon) + "  ₽")))])]), _vm._v(" "), _vm.beautifyPriceDiscount ? _c('div', {
    staticClass: "price__before-discount"
  }, [_c('p', [_vm._v(_vm._s(((_vm.beautifyPriceDiscount) + "  ₽")))])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }